<template>
<div class="new-home-page">
   <l-side :list="List" @hadleSearch="id=> hadleSearch(id)"/>
   <div class="middle-content">
      <m-contnt v-if="$route.query.type =='detail'" :videoUrl="videoUrl"/>
      <game-header :bannerCode="bannerCode" :isShowBanner="true" v-else style="margin-top:0px;border-radius: 6px;overflow: hidden;"></game-header>
      <div class="betBox">
        <el-collapse v-model="activeNames">
         <template v-if="$route.query.type =='detail'">
            <template v-if="detailArr.length > 0 ">
             <el-collapse-item v-for="(ele,index) in detailArr" :key="index + 'detail'" :name="index" :title="ele.name">
              <ul :class="[ele.arr.length == 2 && 'fullpage' ,'detail-list']">
                <li v-for="(val,id) in ele.arr" :key="val.srMatch + id">
                  <p class="betName">{{ val.betName }}</p>
                  <div class="odds">
                    <template v-if="val.active && val.marketStatus == 'Active'">
                       <p @click="handleClickLight(val)">
                          <odds-page :odds="val.odds" :class="{'setactived':matchKey.includes(val.srMatch + '' + val.srMarket + val.betValueId + val.onlyKey)}"></odds-page>
                       </p>
                     </template>
                    <template v-else><p style="cursor: not-allowed;"><img src="./img/suo.png" alt /></p></template>
                  </div>
                </li>
              </ul>
             </el-collapse-item>
           </template>
           <no-data v-else :nodata_img="require('./img/no_match.png')"></no-data>
         </template>

         <template v-else>
            <template v-if="renderList.length > 0 ">
             <el-collapse-item v-for="(item,index) in renderList" :key="index" :name="index" :title="item.name" class="homeItem">
               <div class="yellow_nav">
                  <div><span class="_h">{{ $t('header.Home')}}</span> VS <span>{{ $t('header.Away')}}</span></div>
               </div>
               <ul class="bodyDetails">
                  <li v-for="(type,id) in item.arr" :key="type.sportId + id">
                     <div class="floor" @click="handeleGoDetail(type,item.name)">
                        <span v-if="type.matchStatus != 'not_started'" :class="[type.matchStatus == 'live'&& 'onlyLive','status']">
                           <template>{{ type.matchStatus }}</template>
                        </span>
                        <span v-else class="status">{{ changeIndiaTime(type.startDate) }}</span>
                        <span>{{ type.matchName }}</span>
                     </div>
                     <div class="btn_odds">
                        <div class="h_odds">
                           <!-- hOnlyKey hBetValueId gOnlyKey gBetValueId srMarket srMatch-->
                           <p v-if="type.hActive && (type.matchStatus == 'live' || type.matchStatus == 'not_started')" 
                           @click="handleHodads(type,'home')">
                              <odds-page :odds="type.hOdds" 
                              :class="{'setactived':matchKey.includes(h_key(type))}"></odds-page>
                           </p>
                           <p v-else style="cursor: not-allowed;"><img src="./img/suo.png" alt /></p>
                        </div>
                        <div class="g_odds">
                           <p v-if="type.gActive && (type.matchStatus == 'live' || type.matchStatus == 'not_started')" 
                           @click="handleHodads(type,'away')">
                              <odds-page :odds="type.gOdds" 
                              :class="{'setactived':matchKey.includes(G_key(type))}"></odds-page>
                           </p>
                           <p v-else style="cursor: not-allowed;"><img src="./img/suo.png" alt /></p>
                        </div>
                        <span class="count">+{{ type.count }}</span>
                     </div>
                  </li>
               </ul>
             </el-collapse-item>
            </template>
            <no-data v-else :nodata_img="require('./img/no_match.png')"></no-data>
         </template>
         </el-collapse>
      </div>
   </div>
   <r-side @handleRefer="handleRefer" :againListVo="againListVo" :createdAgainListVo="createdAgainListVo"/>
</div>
</template>

<script>
import LSide from './L-side'
import RSide from './R-side'
import oddsPage from './odds';
import NoData from '../NoData'
import MContnt from './M-contnt'
import { mapState } from 'vuex'
import myevent from './index.js'
import { commonApi } from "@/common/index";
import { parseTime } from "@/common/utils/Date.js";
import GameHeader from '../game-header/game-header'
import { PENDANT_CRICKET_BANNER } from '../../assets/js/bannerCode'
export default {
   components:{ LSide,RSide,GameHeader,MContnt,NoData,oddsPage },
   mixins:[ myevent ],
   data(){
      return {
         List:[],
         videoUrl:'',
         wsJsonObj:{
            info:null,
            srMatch:'',
            match:null
         },
         renderList:[],
         detailArr:[],
         websock: null,
         againListVo:[],
         detailsMatch:{},
         HAVERENDERLIST:[],
         HAVESDETAILSARR:[],
         activeNames: [0,1,2,3,4],
         bannerCode:PENDANT_CRICKET_BANNER,
         matchKey:[],  // 存储所有的 id  主队id 客队 id  还有详情页唯一key
         // wsuri:'ws://30009.flycdnikm22.vip/api/ewrwfwegergqer',
         wsuri:'wss://data.11ic5.com/api/ewrwfwegergqer',
         getBetList:JSON.parse(sessionStorage.getItem('betList'))?JSON.parse(sessionStorage.getItem('betList')):[],
      }
   },
   computed: {
      ...mapState({
        UUID: state => state.UUID,
        isLogin: state => state.isLogin,
      }),
   },
   methods:{
      changeIndiaTime(val){ return parseTime(val) },
      handeleGoDetail({ srMatch,beginStr,matchName,startDate,srHTeam,srGTeam,matchStatus,gTeam,hTeam,hFull,gFull },name){
         this.$router.push({   
            path:'/home',
            query:{ 
            gFull,
            hFull,
            id:srMatch,
            type:'detail',
            time:beginStr,
            name:matchName,
            sj:name,startDate:startDate,
            srGTeam,srHTeam,matchStatus,hTeam,gTeam }
         })
      },
      h_key({srMatch,srMarket,hBetValueId,hOnlyKey}){
         return (srMatch + '' + srMarket + hBetValueId + hOnlyKey)
      },
      G_key({srMatch,srMarket,gOnlyKey,gBetValueId}){
         return (srMatch + '' + srMarket + gBetValueId + gOnlyKey)
      },
      MInit(){  // 详情初始化  最好把主页和详情页分开,没劲分了。后面哥们可以分以下
        if(this.$route.query.hasOwnProperty('id')){ 
         this.$api.post(this.$urls.Cicket.getMatchesInfo,{srMatch :this.$route.query.id},resp=>{
            let data = resp.data
            if(data.code == 200){
               let neswDta = data.data.list
               this.detailsMatch = data.data.match
               this.videoUrl = data.data.url
               this.detailArr=[]
               this.HAVESDETAILSARR = []
               for(let i in neswDta){
                  let Items = neswDta[i]
                  this.detailArr.push({ name:i,arr:Items })
                  this.HAVESDETAILSARR.push(...Items)
               }
            }else{
               this.detailArr = []
            }
            this.detailArrComparedFun(this.HAVESDETAILSARR,this.detailsMatch.matchStatus)
         })
        }
      },
      init(){ // 主页初始化
         this.$api.post(this.$urls.Cicket.matchesAllMatches, {}, resp => {
            let data = resp.data
            this.List = []
            this.HAVERENDERLIST = []
            if(data.code == 200){
               let Sname = Object.keys(data.data)
               let Sbody = Object.values(data.data)
               Sname.map((item,index)=>{
                  let c = Sbody[index].filter(o=>{ return o.srSeason == '91319'})
                  if(c.length > 0){
                     this.List.unshift({ name:item,arr:Sbody[index] })
                  }else{
                     this.List.push({ name:item,arr:Sbody[index] })
                  }
                  this.HAVERENDERLIST.push(...Sbody[index])
               })
               this.renderList = [ ...this.List ]
               if(this.renderList.length <= 0) this.getBetList = []
            }else{
               this.List=[]
               this.renderList = []
            }
            this.renderListComparedFun(this.HAVERENDERLIST)
         })
      },
      hadleSearch(id){
         if(id == 'all') return this.renderList = [...this.List]
         this.renderList = this.List.filter((item,i) =>{
            return id == i
         })
      },
      handleRefer({ getData,sessionData,listVo }){
         listVo.forEach((item,index)=>{
            sessionData.forEach((val,j)=>{
               if(val.teamId == item.teamId){
                  if(getData[index].code != 200){
                     this.$set(this.getBetList,j,{ ...val,'betFailText':getData[index].msg})
                  }else{
                     this.getBetList.splice(j,1);
                     this.getActived()
                  }
                  sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
               }
            })
         })
      },
      handleClearAll(){
         this.getBetList = []
         this.matchKey = []
         this.createdAgainListVo()
         sessionStorage.removeItem('betList')
      },
      detailArrComparedFun(ele,matchStatus){ // 详情页刷新
         if(ele.length > 0){
            ele.map(val=>{
               let teamId = val.srMatch + '' + val.srMarket + val.betValueId + val.onlyKey
               this.getBetList.forEach((item,i)=>{
                  if(item.teamId == teamId){
                     let limit =val.limitLevel.split(',')
                     let teamodds =val.odds
                     let teamname = val.betName
                     let matchName = val.marketName
                     let lastUpdate = val.lastDate
                     let detailBest = { ...val,money:1,limit,teamodds,teamname,matchName,lastUpdate,teamId,matchStatus,defaultType:'2', }
                     this.$set(this.getBetList,i,{ ...item,...detailBest })
                     sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
                  }
               })
            })
         }
      },
      renderListComparedFun(ele){//主页刷新
         if(ele.length >0 ){
            ele.map(type=>{
               this.getBetList.forEach((val,i)=>{
                  let { matchName,srMatch,lastUpdate,srMarket,matchStatus } = type
                   let teamodds,onlyKey,teamId,betValueId ='';
                   let active = false;
                   let homeBets ={}
                   if(val.teamId == this.h_key(type)){  // 主队
                     teamId = this.h_key(type)
                     teamodds = type.hOdds 
                     onlyKey = type.hOnlyKey
                     betValueId = type.hBetValueId
                     active = type.hActive
                     homeBets = { teamodds,teamId,matchName,srMatch,lastUpdate,srMarket,onlyKey,betValueId,matchStatus,active,defaultType:'1' }
                   }else if(val.teamId == this.G_key(type)){  // 客队
                     teamId = this.G_key(type)
                     teamodds = type.gOdds 
                     onlyKey = type.gOnlyKey
                     betValueId = type.gBetValueId
                     active = type.gActive
                     homeBets = { teamodds,teamId,matchName,srMatch,lastUpdate,srMarket,onlyKey,betValueId,matchStatus,active,defaultType:'1' }
                   }
                  this.$set(this.getBetList,i,{ ...val,...homeBets })
                  sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
               })
            })
         }
      },
      RetrieveBalance(){
         if(this.isLogin){ commonApi.PAY.withdrawGames();}
         if(this.UUID){
            setTimeout(()=>{
              commonApi.WALLET.refresh()
            },2000)
         }
      }
   },
   created(){
      this.init()
      this.MInit()
      this.getActived() // 刷新匹配高亮
      this.initWebSocket()
      this.createdAgainListVo()
      this.RetrieveBalance()
   },
   watch:{
     '$route'(){
         if(this.$route.path == '/home'){
            this.init()
            this.MInit() 
            this.initWebSocket()
            this.RetrieveBalance()
         }else{
            if(this.websock){
               this.websock.close() // 关闭websocket
            } 
         }
     }
   },
   destroyed () {
      if(this.websock){ this.websock.close() } 
  	},
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang="scss">
.betBox{
   margin-top:10px;
   .el-collapse{
      border: none;
   }
   .el-collapse-item{
      background-color: #fff;
      margin-bottom:10px;
      box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      overflow: hidden;
      &.homeItem{ .el-collapse-item__header { background-color: #f9f9f9;}}
      .el-collapse-item__header{
         background-color: #fff;
         height:50px;
         line-height: 50px; 
         font-family: Roboto-Black;
         font-size: 16px;
         font-weight: 550;
         color: #222;
         padding-left:20px;
         .el-collapse-item__arrow{
            font-weight: bold;
            font-size:24px;
            line-height: 50px;
            color:#e2bf87;
            transform: rotate(90deg);
            &.is-active{ transform: rotate(270deg);}
         }
      }
      .el-collapse-item__content{ padding-bottom:0px;}
   }
}
.fullpage li{
   width:48.7%!important;
}
.detail-list{
   display:flex;
   flex-wrap: wrap;
   font-size: 14px;
   font-family: Roboto-Black;
   background:#fff;
   padding-left:15px;
   li{
      width:32%;
      color: #222;
      text-align: center;
      font-weight: 550;
      margin:10px 1.3% 10px 0;
      background-color: #f9f9f9;
      .betName{ 
         height:40px;
         line-height: 40px;
      }
      .odds{
         .setactived{ background-color: #e2bf87; color:#fff;}
         p{
            cursor: pointer;
            height:40px;
            line-height: 40px;
            border-radius: 8px;
            display:block; 
            // background-color: #e2f9ff;
            background-color: #D9EDB8;
         }
      }
   }
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/new-home/new-home.vue